import { Tooltip } from "bootstrap";

(function(window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        const glossaryContainers = document.querySelectorAll('.glossary-container');

        glossaryContainers.forEach((glossaryContainer) => {
            // Select the filter and search input elements, and all glossary items
            const filter = glossaryContainer.querySelector(".glossary-filter");

            if (filter) {
                /** @type {HTMLTemplateElement} */
                const glossaryTemplate = document.querySelector('[data-template-id="glossary-filter-item-template"]');

                /** @type {NodeListOf<HTMLDivElement>} */
                let filterItems = filter.querySelectorAll('.filter-item');

                /** @type {HTMLInputElement} */
                const fullTextSearch = glossaryContainer.querySelector(".glossary-search");

                /** @type {NodeListOf<HTMLDivElement>} */
                const glossaryItems = glossaryContainer.querySelectorAll(".glossary-accordion-item");

                /** @type {Array<string>} */
                let activeLetters = [];

                /** @type {Array<string, Array<HTMLDivElement>>} */
                let letterList = [];


                /**
                 * Get the active letters
                 *
                 * @return {Array<string>}
                 */
                const getActiveLetters = () => {
                    // Remove empty entries
                    activeLetters = activeLetters.filter((value) => {
                        return !!value;
                    });

                    return activeLetters;
                }

                /**
                 * Get all used letters
                 *
                 * @param {boolean} update Update the letter list
                 */
                const getLetters = (update = false) => {
                    if (letterList.length > 0 && !update) {
                        return letterList;
                    }

                    if (glossaryItems.length) {
                        glossaryItems.forEach((glossaryItem) => {
                            let letter = glossaryItem.dataset.glossaryLetter;

                            if (letter) {
                                letter = letter.toUpperCase();

                                if (letterList.indexOf(letter) === -1) {
                                    letterList[letter] = [];
                                }
                                letterList[letter].push(glossaryItem);
                            }
                        });
                    }

                    return letterList;
                }

                /**
                 * Generate the filter items based on the used letters
                 *
                 * @param {boolean} update Update the letter list and the filter items
                 */
                const generateFilterButtons = (update = false) => {
                    let letters = getLetters(update);

                    /** @type {Array<string>} **/
                    const letterKeys = Object.keys(letters);

                    if (letterKeys.length) {
                        filter.innerHTML = '';

                        letterKeys.forEach((letter) => {
                            const clone = glossaryTemplate.content.cloneNode(true);
                            /** @type {HTMLDivElement} */
                            const letterHtml = clone.querySelector('.filter-item');

                            letterHtml.dataset.glossaryLetter = letter;
                            letterHtml.textContent = letter;

                            filter.appendChild(letterHtml);
                        });

                        filterItems = filterItems = filter.querySelectorAll('.filter-item');
                    }
                }

                /**
                 * Update the active state of the filter items
                 */
                const updateFilterItems = () => {
                    const letters = getActiveLetters();

                    filterItems.forEach((filterItem) => {
                        const letter = filterItem.dataset.glossaryLetter;

                        if (letters.indexOf(letter) === -1) {
                            filterItem.classList.remove('active');
                        } else {
                            filterItem.classList.add('active');
                        }
                    });
                };

                /**
                 * The event listener for the filter buttons
                 *
                 * @param filterItem
                 * @param e
                 */
                const filterEventListener = (filterItem, e) => {
                    const letter = filterItem.dataset.glossaryLetter.toUpperCase();
                    let active = !filterItem.classList.contains('active');
                    const multiple = e.ctrlKey;

                    if (multiple) {
                        if (active) {
                            activeLetters.push(letter);
                        } else {
                            delete activeLetters[activeLetters.indexOf(letter)];
                        }
                    } else {
                        if (active) {
                            activeLetters = [letter];
                        } else {
                            resetFilter();
                        }
                    }

                    updateFilterItems()
                    applyFilter()
                }

                /**
                 * Clear the full text search input
                 */
                const clearFullTextSearch = () => {
                    if (fullTextSearch) {
                        fullTextSearch.value = '';
                    }
                };

                /**
                 * Deactivate all filter items
                 */
                const deactivateAll = () => {
                    filterItems.forEach((filterItem) => {
                        filterItem.classList.remove('active');
                    });
                };

                /**
                 * Resets the filter
                 */
                const resetFilter = () => {
                    activeLetters = [];

                    clearFullTextSearch();
                    updateFilterItems();

                    glossaryItems.forEach((item) => {
                        item.classList.remove("d-none");
                    });
                }

                const resetButton = glossaryContainer.querySelector(".filter-button");

                if (resetButton) {
                    resetButton.addEventListener('click', resetFilter);
                }


                /**
                 * Apply a filter to show only glossary items starting with a given letter
                 */
                const applyFilter = () => {
                    const letters = getActiveLetters();
                    updateFilterItems();

                    if (letters.length > 0) {
                        glossaryItems.forEach((item) => {
                            const letter = item.dataset.glossaryLetter;

                            if (letters.indexOf(letter) === -1) {
                                if (!item.classList.contains("collapsed")) item.click();
                                item.classList.add("d-none");
                            } else {
                                item.classList.remove("d-none");
                            }
                        });
                    } else {
                        resetFilter();
                    }
                };

                // If all required elements are present, set up the glossary filter and search functionality
                if (filter && glossaryItems) {
                    generateFilterButtons();

                    filterItems.forEach((filterItem) => {
                        filterItem.addEventListener("click", (e) => {
                            filterEventListener(filterItem, e);
                        });
                    });

                    if (fullTextSearch) {
                        fullTextSearch.addEventListener("keyup", (event) => {
                            const search = event.target.value.toLocaleLowerCase();
                            activeLetters = [];
                            updateFilterItems();

                            glossaryItems.forEach((item) => {
                                if (item.textContent.toLocaleLowerCase().includes(search)) {
                                    item.classList.remove("d-none");
                                } else {
                                    item.classList.add("d-none");
                                }
                            });
                        });
                    }
                }
            }
        });

        /**
         * Initialize the glossary tooltips
         */
        const initGlossaryTooltips = () => {
            const tooltipElements = document.querySelectorAll('[data-glossary-tooltip="true"]');

            if (tooltipElements.length > 0) {
                const tooltipTemplate = document.querySelector('#glossary-tooltip-template');

                if (tooltipTemplate) {
                    const glossaryTooltips = document.querySelectorAll('[data-glossary-tooltip="true"]');

                    if (glossaryTooltips.length) {
                        const tooltipConfig = {
                            animation: tooltipTemplate.dataset.glossaryTooltipAnimation === 'true',
                            html: tooltipTemplate.dataset.glossaryTooltipHtml === 'true',
                            placement: tooltipTemplate.dataset.glossaryTooltipPlacement,
                            template: tooltipTemplate.innerHTML
                        };

                        Array.from(glossaryTooltips).forEach((tooltipEl) => {
                            const tooltip = Tooltip.getOrCreateInstance(tooltipEl, tooltipConfig);
                        });
                    }
                }
            }
        }

        // Initialize the tooltips if an event was dispatched
        // This is useful if content is loaded asynchronously
        document.addEventListener(
            'glossary.tooltips.init',
            initGlossaryTooltips,
            {passive: true}
        );


        initGlossaryTooltips();
    });
})(window, document, window.PageLoadedQueue);
